module.exports = __webpack_public_path__ + "static/heatmap-f557a37ebe27a8b6e16d9a970d175006.png";